// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vt_a bhf_b"};